import React from "react";
import Container from "../components/Layouts/Container";
import JobsOttawa from "../components/Jobs/JobsOttawa";

const JobsOttawaPage = () => {
  return (
    <Container>
      <JobsOttawa />
    </Container>
  );
};

export default JobsOttawaPage;
